import React from "react";
import { Link, useLocation } from "react-router-dom";

import SectionTitle from "../general/SectionTitle";
import SmartLink from "../general/SmartLink";

//Round photo, title and text. When the card is about one of the other pages, the photo & title link to it
const Card = ({ item }) => {
  const { pathname } = useLocation();
  const link = item.path && item.path !== pathname ? item.path : null;
  const image = (
    <img
      src={item.image.src}
      alt={item.image.alt}
      width={item.image.width}
      height={item.image.height}
      className={"card-image"}
      loading={"lazy"}
    />
  );
  return (
    <li className={`card ${link ? "has-link" : ""}`}>
      {link ? (
        <Link
          to={link}
          className={"card-image-link"}
          tabIndex={-1}
          aria-hidden={"true"}
        >
          {image}
        </Link>
      ) : image}
      <h3 className={"card-title"}>
        {link ? <Link to={link}>{item.title}</Link> : item.title}
      </h3>
      <p className={"card-text"}>{item.text}</p>
      {item.button ? (
        <SmartLink
          path={item.button.path}
          href={item.button.href}
          className={"btn card-button"}
        >
          {item.button.label}
        </SmartLink>
      ) : null}
    </li>
  );
};

//Heading, optional intro, four round photo cards and an optional button. "tone" is the background: cream / white / grey
const CardSection = ({ title, subtitle, intro, items, button, tone = "white", id }) => (
  <section
    id={id}
    className={`card-section tone-${tone}`}
  >
    <div className={"container-wide"}>
      <SectionTitle>{title}</SectionTitle>
      {subtitle ? <p className={"section-intro is-lead"}>{subtitle}</p> : null}
      {intro ? <p className={"section-intro"}>{intro}</p> : null}
      <ul className={"card-grid"}>
        {items.map((item) => (
          <Card
            key={item.title}
            item={item}
          />
        ))}
      </ul>
      {button ? (
        <div className={"btn-row"}>
          <SmartLink
            path={button.path}
            href={button.href}
            className={"btn"}
          >
            {button.label}
          </SmartLink>
        </div>
      ) : null}
    </div>
  </section>
);

export default CardSection;
